module.exports = __webpack_public_path__ + "asana-1-5e8b053ba5444b2c707941b285a90401.webp";